import {
  FormBuilderMetaFlags,
  IWidgetDirectiveType,
  WidgetType,
  isInputWidget,
} from '@framework/engine';
import {
  ITableSaveDirective,
  TableSaveDirectiveSchema,
} from './ITableSaveDirective';
import { TableSaveDirectiveConfigComponent } from './TableSaveDirectiveConfigComponent';

export const TableSaveDirectiveType: IWidgetDirectiveType<ITableSaveDirective> =
  {
    name: 'tableSave',
    key: 'tableSave',
    allowsWidget: (widget, widgetType) =>
      isInputWidget(widget) && widget.type !== WidgetType.Repeatable,
    configComponent: TableSaveDirectiveConfigComponent,
    configSchema: TableSaveDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema, flags }) => {
      if (!directiveConfig.name) {
        console.warn(`[TableSaveDirectiveType] Missing name in config`);
        return schema;
      }

      if (flags[FormBuilderMetaFlags.SkipValidationRules]) {
        // Se le regole di validazione non sono attive, vuol dire che
        // non è il campo "principale" del Widget, quindi non dobbiamo
        // esportarlo.
        return schema;
      }

      // Salviamo il valore del campo da esportare nei meta, così da accedervi
      // in fase di estrazione
      return schema.meta?.({
        directiveTableSave: directiveConfig.name,
      });
    },
  };
